import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';

import Paginacao from '../../Componentes/Paginacao';
import Carregador from '../../Componentes/Carregador';
import BlackListRegistro from './Registro';
import BlackListParametros from './Parametros';
import ModalCadastro from './ModalCadastro';
import ModalExcluir from './ModalExcluir';

export default function BlacklistConsultar() {

    // estados
    const [parametros, alterarParametros] = useState({
        pagina: 1,
        registrosPorPagina: 10,
        ativo: ['S'],
        texto: ''
    });
    const [consulta, alterarConsulta] = useState([]);
    const [carregando, alterarCarregando] = useState(false);
    const [totalRegistros, atualizarTotalRegistros] = useState(0);
    const [cadastroEmail, alterarCadastroEmail] = useState({
        id: null,
        mostrar: false
    });
    const [idEmailExcluir, alterarIdEmailExcluir ] = useState(null);

    const permissao = useSelector(state => state.login.permissao);

    // consulta emails na lista negra do sistema
    async function consultarEmailsListaNegra() {
        // ativa carregamento
        alterarCarregando(true);

        try {

            // faz a requisição para consultar emails
            const { data } = await axios.get('/emailsListaNegra', {
                params: parametros
            });

            // altera estados com os registros
            alterarConsulta(data.registros);
            atualizarTotalRegistros(parseInt(data.totalRegistros));
        } catch(e) {
            console.error(e);
        } finally {
            // desativa o carregamento
            alterarCarregando(false);
        }
    }

    const mostrarModalCadastro = (idEmail=null) => {
        alterarCadastroEmail({
            mostrar: true,
            id: null
        });
    }

    const esconderModalCadastro = (salvou=false) => {
        alterarCadastroEmail({
            mostrar: false,
            id: null
        });

        // se salvou antes de esconder modal
        if(salvou) {
            // altera parametros na pagina 1 para carregar novamente
            alterarParametros({
                ...parametros,
                pagina: 1
            })
        }
    }

    // inicia
    useEffect(() => {
        consultarEmailsListaNegra();
    }, [parametros]);

    return (
        <>
            <Row>
                <Col>
                    <Card className="painel-consulta border-0 shadow-sm" >
                        <div className="card-header">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <h4 className="card-title font-weight-bolder">
                                    Lista negra de emails
                                </h4>
                            </div>
                            <BlackListParametros
                                parametros={parametros} 
                                alterarParametros={alterarParametros}
                                aoClicarEmCadastrar={mostrarModalCadastro}
                            />
                        </div>
                        <Card.Body>                        
                            <table className="table table-hover tabela">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Responsável</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {consulta.map((registro) => 
                                        <BlackListRegistro
                                            key={registro.dados.id}
                                            dados={registro.dados}
                                            dadosUsuario={registro.dadosUsuario}
                                            permissao={permissao}
                                            clicouExcluir={() => alterarIdEmailExcluir(registro.dados.id)}
                                            clicouEditar={() => {
                                                alterarCadastroEmail({
                                                    id: registro.dados.id,
                                                    mostrar: true
                                                });
                                            }}                                            
                                        />
                                    )}
                                </tbody>
                            </table>
                            <Paginacao
                                pagina={parametros.pagina}
                                registrosPorPagina={parametros.registrosPorPagina}
                                totalRegistros={totalRegistros}
                                alterouPagina={pagina => {
                                    alterarParametros({...parametros, pagina: pagina});
                                }}
                            />
                            {carregando && 
                                <Carregador className="rounded-bottom" />
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {idEmailExcluir && 
                <ModalExcluir
                    id={idEmailExcluir}
                    aoFechar={() => alterarIdEmailExcluir(null)}
                    aoDeletar={() => {
                        // volta ao valor original do estado
                        alterarIdEmailExcluir(null);

                        // altera para a pagina 1 para consultar novamente
                        alterarParametros({
                            ...parametros, 
                            pagina: 1
                        });
                    }}
                />
            }

            {cadastroEmail.mostrar && <ModalCadastro 
                aoFechar={esconderModalCadastro}
                id={cadastroEmail.id}
            />}
        </>
    )
}